const { CONTENT_MODEL_TYPES } = require('@fiverr-private/cms_ui');

const PAGE_NAME = 'landing_page_perseus';

const ROOT_CONTENT_TYPES = {
    CONTENT_LANDING_PAGE: 'contentLandingPage'
};

const BUILDING_BLOCKS_MODEL_TYPES = {
    HERO_MEDIA: 'heroMedia',
    BENEFITS: CONTENT_MODEL_TYPES.BENEFITS,
    GIGS_CAROUSEL: CONTENT_MODEL_TYPES.GIGS_CAROUSEL,
    BANNER: CONTENT_MODEL_TYPES.BANNER,
    AUTHOR: CONTENT_MODEL_TYPES.AUTHOR
};

const PAGE_TYPES = {
    CONTENT_LANDING_PAGE: 'CONTENT_LANDING_PAGE',
    SELLER_JOB_PAGE: 'SELLER_JOB_PAGE'
};

const SELLER_PLUS_CONTENT_KEYWORD = 'SELLER_PLUS_success_resources';

const CMS_PACKAGE_CONTEXT = {
    impressionEnrichment: {
        controllerAction: 'landing_pages#show',
        viewportType: 'landing_pages.show'
    },
    maxStaticItems: 1
};

const SLIDER_BREAKPOINTS = [
    {
        breakpoint: 720,
        slides: 2,

        /**
         * Need to manually set amount of slide items
         * by default @fiverr-private/slider will take default number of items
         * usually 3
         */
        slidesToScroll: 2
    },
    {
        breakpoint: 500,
        slides: 1,
        slidesToScroll: 1
    }
];

const RETENTION_ARTICLE_IDS_TO_REDIRECT = [
    'test-retention-route',
    'open-for-the-holidays',
    'onboarding-generic-get-growing',
    'in-session-recommendations-for-you-pm',
    'sale-20-all-services',
    'black-friday-2021',
    'flash-sale-20-every-single-service',
    'flash-sale-10-every-single-service',
    'stay-one-step-ahead-with-seo',
    'your-wordpress-checklist',
    'social-media-advertising-essentials',
    'MadeOnFiverr-Lavender',
    'black-to-black-friday',
    'fiverr-business-sum-up-your-year',
    'subscriptions-spotlight-ammar',
    'flash-sale',
    'music-checklist',
    'MadeOnFiverr-Rooted',
    'MadeOnFiverr-Haerfest',
    'branding-bundle',
    'digital-marketing-bundle',
    'fiverr-business-perfect-video-brief',
    'black-friday-promotion',
    'flash-sale-2021',
    'subscriptions-custom-offer-webinar',
    'content-bundle',
    'website-bundle',
    'new-listing-experience-email',
    'music-audio-workshops',
    'pride-month-sea-the-love',
    'flash-sale-on-everything',
    'ChristmasNLEN',
    'ChristmasNL',
    'how-fiverr-works',
    'email-marketing-and-copywriting-webinar',
    'fiverr-business-perfect-content-brief',
    'fiverr-beat',
    'pro-sellers-order-communication-webinar',
    'seize-the-season-online',
    'whiteboard-checklist',
    'fiverr-business-next-project-marketing',
    'grow-with-fiverr',
    'fiverr-business-next-project-videos',
    'gig-images',
    'prep-your-e-commerce-for-the-holidays',
    'promoted-gigs-webinar',
    'fiverr-business-bsm-guide',
    'ukraine-freelancers-event',
    '2021-tax-day-checklist',
    'MadeOnFiverr-Adam',
    'flash-sale-on-everything-2021',
    'set-your-holiday-digital-strategy',
    'MadeOnFiverr-Jennifer',
    'MadeOnFiverr-Darryl',
    'sale-do-more-for-less',
    'how-to-make-more-money-in-2021',
    'fiverr-business-next-project-tech',
    'vid-live-onboarding-session-august21',
    'master-classes-session-one',
    'improve-your-listing-for-the-holidays',
    'business-spotlight-osm-aviation',
    'MadeOnFiverr-Les',
    'Easter-2021-egg-hunt-main',
    'grow-with-fiverr2',
    'how-to-launch-a-youtube-channel-checklist',
    'fashion-design-checklist',
    'accelerate-your-holiday-digital-marketing',
    'digital-advertising-webinar',
    'vidspotlight-nicolette',
    'vidspotlight-ofer',
    'vid-live-onboarding-session-feb21',
    'influencer-marketing-webinar-recording',
    'fiverr-business-next-project-content',
    'your-website-promotion-checklist',
    'new-listing-experience',
    '5-email-marketing-essentials',
    'fiverr-business-from-vision-to-visual',
    'master-classes-session-three',
    'fib-marketing-webinar-recording-april21',
    'vidspotlight-paul',
    'vid-live-onboarding-session-june21',
    'master-classes-session-two',
    'essential-prep-for-your-e-commerce',
    'your-wordpress-checklist',
    'packaging-and-branding-checklist',
    'google-ads-essentials',
    'nail-your-video-marketing',
    'build-and-launch-a-wix-website',
    '5-steps-to-create-an-app',
    'the-song-production-checklist',
    'successful-branding-step-by-step',
    'make-your-content-global',
    '4-step-book-publishing-guide',
    'level-up-your-streaming-game',
    'the-job-hunting-guide',
    'bring-your-product-to-life',
    'credit-10-all-services',
    'sale-10-all-services',
    'nft-promotion-101',
    'articles-and-blog-posts-webinar',
    'video-and-animation-webinar',
    'andco-cashback',
    'logo-maker-webinar',
    'seller-plus-creativelive-perk',
    'gallery-tagging-webinar-recording',
    'how-to-launch-your-youtube-channel-webinar'
];

module.exports = {
    ROOT_CONTENT_TYPES,
    CMS_PACKAGE_CONTEXT,
    BUILDING_BLOCKS_MODEL_TYPES,
    SLIDER_BREAKPOINTS,
    PAGE_NAME,
    PAGE_TYPES,
    SELLER_PLUS_CONTENT_KEYWORD,
    RETENTION_ARTICLE_IDS_TO_REDIRECT
};
